module.exports = __webpack_public_path__ + "static/media/virtual-casino.8db0e2b1.svg";